import { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';

type InterruptionFormSectionProps = PropsWithChildren<{
  description?: string;
  step: number;
  title: string;
}>;

const ROOT_SX = {
  borderRadius: 1,
  backgroundColor: 'background.paper',
} as const;

const TITLE_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
} as const;

const STEP_SX = {
  display: 'inline-flex',
  width: 18,
  height: 18,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: 'success.main',
} as const;

const InterruptionFormSection = ({ children, description, step, title }: InterruptionFormSectionProps) => (
  <Box component="section" sx={ROOT_SX}>
    <Typography component="p" variant="subtitle1" color="textSecondary" sx={TITLE_SX}>
      <Typography component="span" variant="caption" color="success.contrastText" sx={STEP_SX}>
        {step}
      </Typography>
      {title}
    </Typography>
    {description ? (
      <Typography variant="body2" color="textSecondary" mt={0.5}>
        {description}
      </Typography>
    ) : null}
    <Box mt={1}>{children}</Box>
  </Box>
);

export default InterruptionFormSection;
